var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/modules/_an-object.js